export default function initMapsLinks() {
	$('.js-maps-link').each(function() {
		const $this = $(this);
		const linkHref = $this.attr('href');

		if ( $this.data('address') ) {
			$this.attr('href', linkHref + $this.data('address').replace(/ /igm, '+'));
		}
	});
}
